/*
 * @Author: 陈朝晖
 * @Date: 2022-02-21 17:56:51
 * @LastEditTime: 2024-09-13 11:45:16
 * @Description:
 */
const isRunningInExamples = process.env.NODE_ENV === 'development'; // 直接serve起来的环境
const isRunningInTest =
    window.dazeRunningConfing && window.dazeRunningConfing.DAZE_APPLICATION_RUNNING_TIME === 'development'; // 外部程序出于测试环境 需要测试站的配套api等
const isDevelop = isRunningInExamples || isRunningInTest;
const isDaze = process.env.VUE_APP_ROLE !== 'yg';
export default {
    defaultImg: isDaze
        ? 'http://oss.fjdaze.com/aliProject/images/no_image100x100.jpg'
        : 'http://oss.91yanggu.com/aliProject/images/no_91_image100x100.jpg',
    // 登录occ地址
    loginbaseUrl: 'https://occ.fjdaze.com',
    // 图片的地址
    imgUrl: isDevelop
        ? 'https://test-oss.fjdaze.com/'
        : location.host.indexOf('127.0.0.1') !== -1 || location.host.indexOf('192.168.0') !== -1
        ? 'https://test-oss.fjdaze.com/'
        : location.host.indexOf('test.fjdaze.com') > -1 ||
          location.host.indexOf('test.fjdaze.cn') > -1 ||
          location.host.indexOf('test.fjdaze.com') > -1
        ? 'https://test-oss.fjdaze.com/'
        : isDaze
        ? 'https://oss.fjdaze.com/'
        : 'https://oss.91yanggu.com/',
    imgUrl2: isDaze ? 'https://oss.fjdaze.com/tools/' : 'https://oss.91yanggu.com/tools/',
    ossUiDomainUrl: isDaze ? 'https://oss.fjdaze.com/' : 'https://oss.91yanggu.com/',
    audioUrl: isDaze ? 'https://oss.fjdaze.com/' : 'https://oss.fjdaze.com/',
    audioUploadUrl: isDaze ? 'https://api.fjdaze.com/' : 'https://api.fjdaze.com/',
    fxUrl: isDaze ? 'https://fx.fjdaze.cn/toep/' : 'https://fx.91yanggu.com/toep/',
    alicdn: 'https://cbu01.alicdn.com/',
    editUrl: isDevelop
        ? 'https://test.fjdaze.com/static/ali-poster-editor/#/'
        : location.host.indexOf('test.fjdaze.com') > -1 || location.host.indexOf('test.fjdaze.cn') > -1
        ? 'https://test.fjdaze.com/static/ali-poster-editor/#/'
        : isDaze
        ? 'https://app.fjdaze.com/static/ali-poster-editor/#/'
        : 'https://zxsq.91yanggu.com/static/ali-poster-editor/#/',
    watermarkEditUrl: isDevelop
        ? 'https://test.fjdaze.com/static/main-pic-watermarking/#/'
        : location.host.indexOf('test.fjdaze.com') > -1 || location.host.indexOf('test.fjdaze.cn') > -1
        ? 'https://test.fjdaze.com/static/main-pic-watermarking/#/'
        : isDaze
        ? 'https://app.fjdaze.com/static/main-pic-watermarking/#/'
        : 'https://zxsq.91yanggu.com/static/main-pic-watermarking/#/',
    mainPicTemplateEditUrl: isDevelop
        ? 'https://test.fjdaze.com/static/main-image-template/#/'
        : location.host.indexOf('test.fjdaze.com') > -1 || location.host.indexOf('test.fjdaze.cn') > -1
        ? 'https://test.fjdaze.com/static/main-image-template/#/'
        : isDaze
        ? 'https://app.fjdaze.com/static/main-image-template/#/'
        : 'https://zxsq.91yanggu.com/static/main-image-template/#/',
    // 视频下载地址
    downloadFun: function () {
        var downloadUrl = '';
        if (isDevelop) {
            downloadUrl = 'http://192.168.0.17:8012/test/';
        } else if (location.host.indexOf('127.0.0.1') > -1) {
            downloadUrl = 'http://192.168.0.17:8012/test/';
        } else if (location.host.indexOf('192.168.0') > -1) {
            downloadUrl = 'http://192.168.0.17:8012/';
        } else if (location.host.indexOf('test.fjdaze.com') > -1 || location.host.indexOf('test.fjdaze.cn') > -1) {
            downloadUrl = 'https://test-api.fjdaze.com/';
        } else {
            downloadUrl = isDaze ? 'https://api.fjdaze.com/' : 'https://api.91yanggu.com/';
        }
        return downloadUrl;
    },
    // dzzxHost: process.env.NODE_ENV === 'development' ? 'http://192.168.0.216:8080/#/' : '/static/dzxx/index.html#/',
    dzzxHost: !isDevelop
        ? 'https://app.fjdaze.com/static/dzxx/index.html#/'
        : 'https://app.fjdaze.com/static/dzxx/index.html#/',
    pictureUpload: isDevelop
        ? 'http://192.168.0.17:8012/test/'
        : isDaze
        ? 'https://api.fjdaze.com/'
        : 'https://api.91yanggu.com/',
    aliAlbumHost: 'https://cbu01.alicdn.com/',
    DOMAIN: isDevelop
        ? 'https://test.fjdaze.com/'
        : location.host.indexOf('127.0.0.1') !== -1 || location.host.indexOf('192.168.0') !== -1
        ? 'https://test.fjdaze.com/'
        : location.host.indexOf('test.fjdaze.com') > -1 || location.host.indexOf('test.fjdaze.cn') > -1
        ? 'https://test.fjdaze.com/'
        : '',
    DOMAINHttp: process.env.NODE_ENV === 'development' ? 'http://test.fjdaze.com' : '',
    IFRAME_HOST: process.env.NODE_ENV === 'development' ? 'https://sjzl.fjdaze.com' : '',
    aicenter: isDevelop
        ? 'https://test-aicenter.fjdaze.cn'
        : location.host.indexOf('127.0.0.1') !== -1 || location.host.indexOf('192.168.0') !== -1
        ? 'https://test-aicenter.fjdaze.cn'
        : location.host.indexOf('test.fjdaze.com') > -1 || location.host.indexOf('test.fjdaze.cn') > -1
        ? 'https://test-aicenter.fjdaze.cn'
        : 'https://aicenter.fjdaze.cn',
};
